import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Tag from "@casino/legacyUi/Tag";
import getBadge from "./helpers";

type Props = { game: GameFragment };

const GameBadge: FC<Props> = ({ game }) => {
  const badge = getBadge(game);

  if (!badge) {
    return null;
  }

  return (
    <div className="absolute left-2 top-2 sm:left-3 sm:top-3">
      <Tag
        className="px-1 sm:px-2"
        bgColor={badge.color}
        color="text-white"
        size="2xs"
      >
        <Translate
          id={`game.label_${badge.type}`}
          className="tracking-normal sm:tracking-wide"
        />
      </Tag>
    </div>
  );
};

export default GameBadge;
